import React from 'react';

import { ThemeType } from '../../../@types';
import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import type { IconType } from '../icon/types';
import Title from '../title/Title';
import styles from './searchState.module.scss';

type SearchStateProps = {
  iconTop: React.ReactNode;
  title: string;
  iconTitle?: IconType;
  message: string;
};

const SearchState: React.FC<SearchStateProps> = ({
  iconTop,
  title,
  iconTitle,
  message,
}) => {
  const { kiosk, kioskMode } = useKioskManager();

  return (
    <div
      className={`${styles.stateContainer} ${
        kiosk && kioskMode && styles[kiosk.model]
      }`}
    >
      <div className={styles.iconTop}>{iconTop}</div>
      <div className={styles.titleContainer}>
        {iconTitle && (
          <div className={styles.icon}>
            <Icon icon={iconTitle} theme={ThemeType.PRIMARY} size="full" />
          </div>
        )}
        <Title as="h3">{title}</Title>
      </div>
      <p className={styles.message}>{message}</p>
    </div>
  );
};

export default SearchState;
